export class ApiConfig {
  static CLINIC_BASE = "/clinic/api";
  static MEETING_BASE = "/v1/telemed";
  static ACCOUNT_BASE = "/v1/account/api";
  static LOCATION_BASE = "/v1/location/api";
  static INVENTORY_BASE = "/v1/inventory/api";
  static PAYMENT_BASE = "/v1/payment/api";
  static LINE_OA_BASE = "/line-oa/api";
}
